import React from "react";
export default function ApiPage() {
  return (
    <div className="bg-[#0B0F19] text-emerald-300 font-mono text-sm rounded-xl p-6" data-testid="api-page">
      <p className="text-slate-500 mb-3">// POST /api/quote</p>
<pre className="text-slate-300">{`{
  "mode": "maritimo",
  "origen_pais": "China",
  "destino_pais": "Siria",
  "china_city": "Guangzhou",
  "tipo_carga": "cbm",
  "cbm": 2.5,
  "peso": 450
}`}</pre>
    </div>
  );
}
